import { render, staticRenderFns } from "./StatsHeader.vue?vue&type=template&id=9f6217a2&scoped=true&"
import script from "./StatsHeader.vue?vue&type=script&lang=js&"
export * from "./StatsHeader.vue?vue&type=script&lang=js&"
import style0 from "./StatsHeader.vue?vue&type=style&index=0&id=9f6217a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6217a2",
  null
  
)

export default component.exports